import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs';
import { ApiLineLiffService } from '../services/api/Line-liff/api-line-liff';

/**
 * Guest pages (register-form / OTP): allow when LINE session is reg_pending.
 * If already a registered member, redirect into the app.
 */
export const GuestGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const apiLineLiffService = inject(ApiLineLiffService);
  const redirectPath = route.queryParamMap.get('redirect') || '/home';


  return apiLineLiffService.verifyToken().pipe(
    map((response) => {
      // Member cookie valid → leave guest pages
      if (response.code === '000') {
        return router.createUrlTree([redirectPath]);
      }
      return true;
    }),
    catchError(() => {
      // No member token (401) — may still have reg_pending cookie; allow guest flow
      return of(true);
    }),
  );
};
